import { c as _c } from "react/compiler-runtime";
import { IconProps } from '../types';
export function ActiveTagIcon(t0) {
  const $ = _c(17);
  const {
    width: t1,
    height: t2,
    fill: t3
  } = t0;
  const width = t1 === undefined ? 65 : t1;
  const height = t2 === undefined ? 71 : t2;
  const fill = t3 === undefined ? "currentColor" : t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== fill) {
    t4 = <rect x="20.4004" y="20" width="24" height="24" rx="12" fill={fill} shapeRendering="crispEdges" />;
    t5 = <path d="M44.8 32.4C44.8 41.7 32.4 51 32.4 51C32.4 51 20 41.7 20 32.4C20 29.1113 21.3064 25.9573 23.6319 23.6319C25.9573 21.3064 29.1113 20 32.4 20C35.6887 20 38.8427 21.3064 41.1681 23.6319C43.4936 25.9573 44.8 29.1113 44.8 32.4Z" fill={fill} />;
    t6 = <path d="M32.4 37.05C34.9681 37.05 37.05 34.9681 37.05 32.4C37.05 29.8319 34.9681 27.75 32.4 27.75C29.8319 27.75 27.75 29.8319 27.75 32.4C27.75 34.9681 29.8319 37.05 32.4 37.05Z" fill={fill} />;
    $[0] = fill;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t4 = $[1];
    t5 = $[2];
    t6 = $[3];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <path d="M32.4007 26.5348C33.6889 26.5348 34.9643 26.7889 36.1544 27.2819C37.3444 27.7748 38.4259 28.4973 39.3368 29.4081C39.5346 29.6059 39.5346 29.9266 39.3368 30.1244C39.139 30.3221 38.8182 30.3222 38.6205 30.1244C37.8037 29.3077 36.8341 28.6599 35.7669 28.2179C34.6997 27.7758 33.5559 27.5485 32.4007 27.5485C31.2455 27.5484 30.1011 27.7758 29.0338 28.2179C27.9667 28.66 26.997 29.3077 26.1803 30.1244C25.9825 30.3222 25.6618 30.3222 25.464 30.1244C25.2663 29.9266 25.2662 29.6058 25.464 29.4081C26.3748 28.4972 27.4563 27.7748 28.6463 27.2819C29.8365 26.7889 31.1125 26.5348 32.4007 26.5348Z" fill="black" />;
    t8 = <path d="M35.7605 32.7097C35.3194 32.2686 34.7956 31.9189 34.2192 31.6801C33.6428 31.4413 33.0248 31.3181 32.4009 31.3181C31.7769 31.3181 31.1585 31.4408 30.582 31.6796C30.0055 31.9184 29.482 32.269 29.0408 32.7102C28.843 32.908 28.5218 32.908 28.324 32.7102C28.1262 32.5124 28.1262 32.1912 28.324 31.9934C28.8593 31.4581 29.4952 31.034 30.1946 30.7443C30.8941 30.4546 31.6439 30.3051 32.4009 30.3051C33.1578 30.3051 33.9073 30.4541 34.6066 30.7437C35.306 31.0334 35.9415 31.4582 36.4768 31.9934C36.6746 32.1912 36.6746 32.5124 36.4768 32.7102C36.279 32.9078 35.9582 32.9074 35.7605 32.7097Z" fill="black" />;
    t9 = <path d="M33.2641 36.9224C33.7379 36.4485 33.7379 35.6801 33.264 35.2063C32.7902 34.7324 32.0218 34.7324 31.5479 35.2063C31.074 35.6802 31.0741 36.4485 31.5479 36.9224C32.0218 37.3963 32.7902 37.3963 33.2641 36.9224Z" fill="black" />;
    t10 = <path d="M33.1318 35.3387C32.7312 34.9381 32.0813 34.9382 31.6806 35.3387C31.28 35.7394 31.28 36.3892 31.6806 36.7899C32.0813 37.1904 32.7311 37.1905 33.1318 36.7899C33.5323 36.3893 33.5323 35.7394 33.1318 35.3387ZM33.3969 35.0736C33.9439 35.6206 33.9439 36.508 33.3969 37.0551C32.8499 37.6021 31.9626 37.6021 31.4155 37.0551C30.8684 36.508 30.8683 35.6207 31.4155 35.0736C31.9626 34.5266 32.8499 34.5265 33.3969 35.0736Z" fill="black" />;
    $[4] = t10;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t10 = $[4];
    t7 = $[5];
    t8 = $[6];
    t9 = $[7];
  }
  let t11;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t11 = <g filter="url(#filter0_d_4961_10666)">{t4}{t5}{t6}{t7}{t8}{t9}{t10}</g>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <defs><filter id="filter0_d_4961_10666" x="0" y="0" width="65" height="71" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB"><feFlood floodOpacity="0" result="BackgroundImageFix" /><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" /><feOffset /><feGaussianBlur stdDeviation="10" /><feComposite in2="hardAlpha" operator="out" /><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" /><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4961_10666" /><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4961_10666" result="shape" /></filter></defs>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== height || $[14] !== t11 || $[15] !== width) {
    t13 = <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 65 71" fill="none">{t11}{t12}</svg>;
    $[13] = height;
    $[14] = t11;
    $[15] = width;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  return t13;
}